module.exports = __webpack_public_path__ + "static/media/lo12v2.ced1cf71.png";